import axios from 'axios';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';

export interface vinDetailsResponse {
    isValid: boolean;
    message: string;
    assetDetails?: AssetDetails;
    customerDetails?: CustomerDetails;
    errorCode?: string;
    modelDetails?: ModelDetails;
}

export interface CustomerDetails {
    name: string;
    phone: string;
    email: string;
    address: string;
    pincode: string;
}

export interface AssetDetails {
    asset_number: string;
    name: string;
    purchase_date: string;
    motor_number: string;
    charger_number: string;
    bin: string;
    bin2: string;
    rto_code: string;
    registration_number: string;
}

export interface ModelDetails {
    description: string;
    id: string;
    name: string;
    price: number;
    type: string;
    brand: string;
}

export const validateVinNumber = async (
    partnerId: string,
    vin_number: string,
    group: string
): Promise<vinDetailsResponse> => {
    try {
        const { data } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/asset-details?serial_number=${vin_number}&group_name=${group}`,
            ...getAxiosConfig(),
        });
        return {
            message: data?.message,
            isValid: data?.is_valid,
            assetDetails: data?.asset_details,
            customerDetails: data?.customer_details,
            errorCode: data?.errorCode,
            modelDetails: data?.model_details,
        };
    } catch (error: any) {
        const message = error?.response?.data?.message;
        return {
            isValid: false,
            message,
            errorCode: error?.response?.data?.errorCode,
        };
    }
};
